import React from "react";
import { Box, Grid } from "grommet";
import { ImageWithLink } from "../ImageWithLink";
import infoImage1 from "../../images/home/ExtraInfo/ExtraInfo_img_1.jpg";
import infoImage2 from "../../images/home/ExtraInfo/ExtraInfo_img_2.jpg";
import { routes } from "../../const/routes";
var extraInfoArray = [
  {
    id: 0,
    title: "\u0421\u0431\u043E\u0440\u043D\u0430\u044F",
    description: "\u0421\u0431\u043E\u0440\u043D\u0430\u044F",
    image: infoImage1,
    link: routes.mainCast.path,
  },
  {
    id: 1,
    title: "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C",
    description: "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C",
    image: infoImage2,
    link: routes.calendar.path,
  },
];
export var ExtraInfo = function ExtraInfo(_ref) {
  var as = _ref.as;
  return /*#__PURE__*/ React.createElement(
    Grid,
    {
      columns: {
        count: "fit",
        size: "330px",
      },
      gap: "24px",
    },
    extraInfoArray.length > 0
      ? extraInfoArray.map(function (item) {
          return /*#__PURE__*/ React.createElement(
            Box,
            {
              width: {
                max: "598px",
              },
            },
            /*#__PURE__*/ React.createElement(ImageWithLink, {
              as: as,
              key: item.id,
              image: item.image,
              heading: item.title,
              paragraph: item.description,
              link: item.link,
              extraInfo: true,
            })
          );
        })
      : null
  );
};
